import { useAppSelector } from 'app/hooks';
import Button from 'blocks/Button';
import Col from 'blocks/Col';
import Row from 'blocks/Row';
import Tooltip from 'blocks/Tooltip';
import Paths from 'helper/paths';
import { Maybe } from 'models/types';
import { useEffect, useRef, useState } from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { tierState } from 'store/dashboard/dasboardSlice';
import { TierInterface } from 'store/dashboard/dasboardSlice.interface';
import ModalQR from './component/ModalQRcode';
import { CustomTierInterface } from './tierStatus.interface';
import * as S from './tierStatus.styles';

const percentageCalculation = (mile, max): number => {
  if (mile > max) {
    return 100;
  }
  return Number(Math.floor((mile / max) * 100));
  // return Number(((mile / max) * 100).toFixed());
};

const TierStatus = ({ tierMilage, idNumber, userTierId, typeUser }) => {
  const { t } = useTranslation();
  const QRCodeModal = useRef<any>();
  const navigate = useNavigate();

  const [earnedTier, setEarnedTier] = useState<Maybe<TierInterface>>(null);
  const [preparedTiers, setPreparedTiers] = useState<CustomTierInterface[]>([]);
  const tiers = useAppSelector(tierState);
  useEffect(() => {
    const preparedTiers = JSON.parse(JSON.stringify(tiers))
      .filter((item) => item.type === typeUser)
      .map((item) => {
        console.log(item.type, typeUser);
        const remainToFull = item.minMilage - tierMilage;
        item.remainToFull = remainToFull >= 0 ? remainToFull : 0;
        item.percent = percentageCalculation(tierMilage, item.minMilage);
        if (item.percent === 100) setEarnedTier(item);
        return item;
      });
    setPreparedTiers(preparedTiers);
  }, [tiers, tierMilage]);
  // for (let i = tiers.length - 1; i >= 0; i--) {
  //   const tier = tiers[i];
  //   if (tier.minMilage <= tierMilage) {
  //     setEarnedTier(tier);
  //     break;
  //   }
  // }
  const handlerCheckoutClaimMiles = () => {
    navigate(Paths.Miles.claim().route);
  };
  const handlerQRcode = () => {
    QRCodeModal.current.openModal(idNumber);
  };
  return (
    <S.Wrapper>
      <S.RowWrapper>
        <S.RowLevel as={Row} flex="1" justify="space-around" align="stretch">
          {preparedTiers.map((item) => (
            <S.ColTier as={Col} align="center" key={item.id}>
              <S.WrapperText>
                <S.ProgressBarTitle $color={item.color}>{item.name}</S.ProgressBarTitle>
                <S.LeftOver>{item.remainToFull === 0 ? '' : `${tierMilage} / ${item.minMilage}`}</S.LeftOver>
              </S.WrapperText>
              <S.ProgressBarWrapper>
                <Tooltip
                  width={240}
                  position="bottom"
                  text={t('pages.dashboard.tiers.tooltipDescription', { minMilage: item.minMilage })}
                >
                  {userTierId == item.id ? (
                    <S.Dashed>
                      <CircularProgressbarWithChildren
                        value={item.percent || 0}
                        maxValue={100}
                        styles={buildStyles({
                          pathColor: item.color,
                          trailColor: '#CFD8DC',
                        })}
                      >
                        <S.TextLevel>Your Level </S.TextLevel>
                        <S.Percentage>{`${item.percent} %`}</S.Percentage>
                        <S.Date>
                          {tierMilage}/{item.minMilage}
                        </S.Date>
                      </CircularProgressbarWithChildren>
                    </S.Dashed>
                  ) : (
                    <CircularProgressbarWithChildren
                      value={item.percent || 0}
                      maxValue={100}
                      styles={buildStyles({
                        pathColor: item.color,
                        trailColor: '#CFD8DC',
                      })}
                    >
                      <S.Percentage>{`${item.percent} %`}</S.Percentage>
                      <S.Date>
                        {tierMilage}/{item.minMilage}
                      </S.Date>
                    </CircularProgressbarWithChildren>
                  )}
                </Tooltip>
              </S.ProgressBarWrapper>
            </S.ColTier>
          ))}
        </S.RowLevel>
      </S.RowWrapper>

      {/* <S.ProgresBarText>
        {earnedTier ? (
          <S.UserTierStatus as={Text} size="small" bold={true} $color={earnedTier.color}>
            {t('pages.dashboard.tiers.claimedTier', { tier: earnedTier.name })}
          </S.UserTierStatus>
        ) : (
          <Text size="small" bold={true} color="error">
            {t('pages.dashboard.tiers.withoutTier')}
          </Text>
        )}
      </S.ProgresBarText> */}
      <S.ParentBtnDahboard>
        <S.Button as={Button} onClick={() => handlerCheckoutClaimMiles()}>
          {t('pages.dashboard.tiers.qualifyCTA')}
        </S.Button>
        <S.Button as={Button} onClick={() => handlerQRcode()}>
          {t('pages.dashboard.tiers.QRcode')}
        </S.Button>
      </S.ParentBtnDahboard>

      <ModalQR ref={QRCodeModal} />
    </S.Wrapper>
  );
};

export default TierStatus;
